module.exports = __webpack_public_path__ + "static/media/logo_full.8a263837.jpg";